import { animate } from 'animejs';
import { refs, domReady, booleanDataset, hasBooleanDataset } from '../modules/utils.js';

class AccordionMeta extends HTMLElement {
  static get observedAttributes() {
    return ['data-index'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-index') {
      const index = parseInt(newValue);
      const oldIndex = parseInt(oldValue);
      this.refs.items?.forEach((el, i) => booleanDataset(el, 'active', i === index));
      this.#toggleItem(index);
      this.#toggleItem(oldIndex);
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.refs.tops?.forEach(el => {
      el.addEventListener('click', () => {
        const index = this.refs.tops.indexOf(el);
        this.dataset.index = index === parseInt(this.dataset.index) ? -1 : index;
      });
    });
  }

  #toggleItem(index) {
    if (isNaN(index) || index < 0) return;
    const el = this.refs.items[index];
    const isActive = hasBooleanDataset(el, 'active');
    const contentEl = el.querySelector('[data-content]');
    if (!contentEl) return;

    let height = 0;
    if (isActive) {
      contentEl.style.height = 'auto';
      height = contentEl.offsetHeight;
      contentEl.style.height = null;
    }

    animate(
      contentEl,
      {
        height,
        duration: 300,
        ease: 'outQuad',
      }
    );
  }
}

customElements.define('accordion-meta', AccordionMeta);
